import store from '@/store';

class StoreCleanup {
  constructor() {
    this.routeCleanupMap = {
      // Entity pages - clear entity-related data
      'EntityData': ['entity', 'entityData', 'entityFields'],
      'EntityDetailedView': ['entity', 'entityData', 'entityFields'],
      'EntityDetailedEdit': ['entity', 'entityData', 'entityFields'],
      
      // Dashboard pages - clear dashboard data
      'Dashboard': ['dashboard', 'charts', 'analytics'],
      'CustomDashboardList': ['dashboard', 'charts', 'analytics'],
      
      // Form pages - clear form data
      'FormBuilderList': ['formBuilder', 'formData'],
      'FormBuilderUserData': ['formBuilder', 'formData'],
      'FormbuilderView': ['formBuilder', 'formData'],
      
      // Template pages - clear template data
      'Templates': ['templates', 'templateData'],
      'CreateFormTemplate': ['templates', 'templateData'],
      
      // Default cleanup for all pages
      'default': ['tempData', 'cache', 'filters']
    };
  }

  // Clear store modules based on route
  clearStoreForRoute(routeName) {
    const modulesToClear = this.routeCleanupMap[routeName] || this.routeCleanupMap['default'];
    
    console.log(`🧹 Clearing store modules for route ${routeName}:`, modulesToClear);
    
    modulesToClear.forEach(moduleName => {
      try {
        // Clear module state if it exists
        if (store.state[moduleName]) {
          // Reset to initial state
          const module = store._modules.root._children[moduleName];
          if (module && module.state) {
            Object.keys(module.state).forEach(key => {
              if (typeof module.state[key] === 'object' && module.state[key] !== null) {
                if (Array.isArray(module.state[key])) {
                  store.commit(`${moduleName}/RESET_${key.toUpperCase()}`, []);
                } else {
                  store.commit(`${moduleName}/RESET_${key.toUpperCase()}`, {});
                }
              }
            });
          }
        }
      } catch (error) {
        console.warn(`⚠️ Could not clear store module ${moduleName}:`, error.message);
      }
    });
  }

  // Clear large data arrays that might be cached
  clearLargeDataArrays() {
    const largeDataKeys = [
      'entityDataList',
      'formDataList', 
      'templateDataList',
      'dashboardData',
      'chartData',
      'tableData'
    ];

    largeDataKeys.forEach(key => {
      try {
        // Clear from root state
        if (store.state[key]) {
          store.commit('CLEAR_LARGE_DATA', { key, value: null });
        }
        
        // Clear from all modules
        Object.keys(store.state).forEach(moduleName => {
          if (store.state[moduleName] && store.state[moduleName][key]) {
            store.commit(`${moduleName}/CLEAR_LARGE_DATA`, { key, value: null });
          }
        });
      } catch (error) {
        console.warn(`⚠️ Could not clear large data ${key}:`, error.message);
      }
    });
  }

  // Force garbage collection hint
  suggestGarbageCollection() {
    // Clear any cached references
    if (window.gc) {
      window.gc();
    }
    
    // Clear any global variables that might be holding references
    if (window.tempData) {
      window.tempData = null;
    }
    if (window.cachedResponses) {
      window.cachedResponses = null;
    }
  }
}

export default new StoreCleanup();
